import { Grid, styled,Tab, Tabs } from '@mui/material';
import { Box } from '@mui/system';
import Localization from 'l18n/l18n';
import * as React from 'react';
import AttachedFilesTab from './tab_panels/attached_files_tab';
import PreviousVisitsTab from './tab_panels/previous_visits_tab';

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ pt: 3 }}>{children}</Box>}
    </div>
  );
}
function a11yProps(index) {
  return {
    id: `vertical-tab-${index}`,
    'aria-controls': `vertical-tabpanel-${index}`,
  };
}
function PatientTabs(props) {
  const [currentTab, setCurrentTab] = React.useState(0);
  const {patientReport} = props; 
  const {appointments , patient_records} = patientReport || {} ;
  const handleTabChange = (event, newValue) => {
    setCurrentTab(newValue);
  };

  const StyledTabs = styled(Tabs)({
    '& .MuiTabs-indicator': {
      height: 0,
    },
  });
  const StyledTab = styled((props) => <Tab disableRipple {...props} />)(
    ({ theme }) => ({
      marginRight: theme.spacing(0),
      minWidth: 0,
      [theme.breakpoints.up('sm')]: {
        minWidth: 0,
        marginRight: theme.spacing(5),
      },
      color: '#757575',
      '&:hover': {
        color: '#40a9ff',
        opacity: 1,
      },
      '&.Mui-selected': {
        color: '#279BFF',
        fontWeight: 'bold',
        fontSize: '1rem',
        background: '#CBE7FF',
        borderRadius: '10rem',
        border: 0,
      },
    })
  );
  return (
    <Grid
      container
      sx={{
        background: '#F4F9FC',
        borderBottomLeftRadius: '1rem',
        borderBottomRightRadius: '1rem',
      }}
      justifyContent="center"
    >
      <Grid item xs={12} md={11}>
        <StyledTabs
          variant="scrollable"
          value={currentTab}
          onChange={handleTabChange}
          aria-label="scrollable prevent tabs example"
        >
          <StyledTab
            {...a11yProps(0)}
            label={Localization.translate['previous_visit']}
          />
          {/* Patient notes button tab */}
          {/* <StyledTab label={Localization.translate['notes']} /> */}
          <StyledTab label={Localization.translate['attached_files']} />
        </StyledTabs>
      </Grid>
      <Grid item xs={12} md={10}>
        <TabPanel value={currentTab} index={0}>
          <PreviousVisitsTab appointments={  appointments || [] } />
        </TabPanel>

        {/* /** Patient Notes tab  */}
        {/* <TabPanel value={currentTab} index={1}>
          <NotesTab />
        </TabPanel> */}
        <TabPanel value={currentTab} index={1}>
          <AttachedFilesTab records={patient_records || [] } />
        </TabPanel>
      </Grid>
    </Grid>
  );
}

export default PatientTabs;
